import focusManager from "focus-manager";
import {ToggleScroll} from "@main/components/toggle-scroll";

/** Класс модального окна c биографией. */
class BiographyModal {
    /**
     * Конструктор класса.
     *
     * @param {HTMLElement} el Элемент.
     */
    constructor(el) {
        this.el = el;
        this.documentEl = this.el.closest("body");
        this.modal = this.documentEl.querySelector(".js-modal-biography");
        this.dataButtonContent = this.el.dataset.content;
        this.modalContents = this.modal.querySelectorAll(".js-biography-content");

        this.listenEvents();
    }

    /**
     * Прослушивание событий.
     *
     * @returns {void}
     */
    listenEvents() {
        this.el.addEventListener("click", () => {
            this.modal.classList.add("shown");
            ToggleScroll.disable(this.modal);
            focusManager.capture(this.modal);
            this.modalContentShow();
        })
    }

    /**
     * Показываем блок с текстом, соответсвующий дата-атрибуту нажатой кнопки.
     *
     * @returns {void}
     */
    modalContentShow() {
        this.modalContents.forEach(item => {
            if(!item.classList.contains("hidden")) {
                item.classList.add("hidden");
            }
            if(item.dataset.content == this.dataButtonContent) {
                item.classList.remove("hidden");
            }
        })
    }
}

window.addEventListener("load", () => {
    document.querySelectorAll(".js-open-biography-modal").forEach((item) => new BiographyModal(item));
});

